export default class ImageFooter {

    constructor(viewer, footerHeight) {

        this.footerHeight = footerHeight;
        this.viewer = viewer;

    }
    
    load(urlTemplate) {
        const containerWidth = this.viewer.extent.canvasSize.x;
        const url = _buildUrl(urlTemplate, this.footerHeight, containerWidth);
        const image = _loadImage(url);
        image.onload = e => {
            if ( this.viewer ) {
                __drawOnCanvas(this.viewer, image, this.footerHeight);
                if(this.redrawSubscription) {
                    this.redrawSubscription.unsubscribe();
                } 
                this.redrawSubscription = this.viewer.onUpdate.subscribe( () => __drawOnCanvas(this.viewer, image, this.footerHeight));
            }
        } 
    }

    unloadFooter() {
        if(this.redrawSubscription) {
            this.redrawSubscription.unsubscribe();
        }
        this.viewer.openseadragon.viewer.update();
    }

}

function _loadImage(url) {
    const image = new Image();
    image.crossOrigin = "anoymous";
    image.src = url;
    return image;
}

function __drawOnCanvas( viewer, footerImage, footerHeight ) {
    if (viewer.openseadragon?.viewport && footerImage && footerHeight > 0 ) {
        var footerPos = new OpenSeadragon.Point( 0, viewer.extent.canvasSize.y - footerHeight );
        var footerSize = new OpenSeadragon.Point( viewer.extent.canvasSize.x, footerHeight );
        
        const canvasScale = viewer.openseadragon.drawer.context.canvas.width / viewer.openseadragon.drawer.context.canvas.clientWidth;
        
        if ( canvasScale != 1 ) {
            footerPos = footerPos.times( canvasScale );
            footerSize = footerSize.times( canvasScale );
        }
        viewer.openseadragon.drawer.context.drawImage( footerImage, Math.floor(footerPos.x), Math.floor(footerPos.y), Math.ceil(footerSize.x), Math.ceil(footerSize.y) );
    }
};

function _buildUrl(urlTemplate, height, width) {
        let url;
        if(urlTemplate.includes("{height") || urlTemplate.includes("{width}")) {
            url = urlTemplate.replace( "{width}", Math.ceil( width ) ).replace( "{height}", Math.ceil( height ) );   
        } else {
            url = urlTemplate.replace( "/full/max/", "/full/!" + Math.ceil( width ) + "," +  Math.ceil( height ) + "/");                
        }
        return url;
}